import InnerComponent from '@Components/Purchase/AccountPayableInvoice/AccountPayableInvoiceForm';
import orgContainer from '@Components/AppContainer';

const AccountPayableInvoiceForm = () => ((orgContainer(InnerComponent)));
export default AccountPayableInvoiceForm;
